import React from 'react'
import Agreement from './Agreement'
import Home from './Home'
import {  Route,Routes } from "react-router-dom";
import LoadForm from './LoadForm';
import Services from './Services';
import Testimonials from './Testimonials';
import Contact from './Contact';
import About from './About';
import LoadTable from './LoadTable';
import Resources from './Resources';
function App() {
  return (
    <div>
      <Routes>
<Route path='/' element={<Home/>}/>
<Route path='/agreement' element={<Agreement/>}/>
<Route path='/form' element={<LoadForm/>}/>
<Route path='/services' element={<Services/>}/>
<Route path='/testinomials' element={<Testimonials/>}/>
<Route path='/contact' element={<Contact/>}/>
<Route path='/aboutus' element={<About/>}/>
<Route path='/allloads' element={<LoadTable/>}/>
<Route path='/resources' element={<Resources/>}/>
      </Routes>
    </div>
  )
}

export default App